import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CharacterImage } from 'src/components/shared/CharacterImage';
import { replaceAllSpaces } from 'src/lib/utils';
import { UserResortProfile } from 'src/models/resort/UserResortProfile';
import { FollowingStar } from '../../common/FollowingStar';

interface PlayerInfoProps {
  profile: UserResortProfile;
  isFollowing: boolean;
}

export const PlayerInfo: React.FC<PlayerInfoProps> = ({
  profile: { image, name, screening, resortPlannerGrade },
  isFollowing
}) => {
  const { t } = useTranslation(['best_friends', 'translation']);
  const isReported = screening === 'ng';
  return (
    <div
      className={css`
        display: flex;
        align-items: center;
        color: #756855;
        .player-image {
          position: relative;
          flex: 0 0 auto;
          width: 40px;
          height: 40px;
          margin-right: 12px;
          .star {
            position: absolute;
            top: -4px;
            right: -4px;
          }
        }
        .player-info {
          flex: 1 1 auto;
        }
        .player-grade {
          font-size: 12px;
        }
        .player-name {
          font-size: 16px;
        }
      `}
    >
      <div className="player-image">
        <CharacterImage
          src={image}
          isReported={isReported}
          isPlayer={true}
          imageAriaLabel={t('aria_player_image')}
        />
        <div className="star">
          <FollowingStar size={16} isFollowing={isFollowing ?? false} />
        </div>
      </div>
      <div className="player-info">
        <p className="player-grade">{resortPlannerGrade}</p>
        <p className="player-name">
          {isReported ? t('translation:reported_player') : replaceAllSpaces(name)}
        </p>
      </div>
    </div>
  );
};
